module.exports = __webpack_public_path__ + "static/media/tree-border.c54dcb86.svg";